module.exports = __webpack_public_path__ + "assets/img/whole_goods1.753670cb.jpg";